import script from "./GridItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GridItem.vue?vue&type=script&setup=true&lang=js"

import "./GridItem.vue?vue&type=style&index=0&id=3380633e&lang=css"

const __exports__ = script;

export default __exports__